import { render } from "./SelfAssessmentV2Navigation.vue?vue&type=template&id=191291b6&scoped=true"
import script from "./SelfAssessmentV2Navigation.vue?vue&type=script&lang=js"
export * from "./SelfAssessmentV2Navigation.vue?vue&type=script&lang=js"

import "./SelfAssessmentV2Navigation.vue?vue&type=style&index=0&id=191291b6&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-191291b6"]])

export default __exports__